import { RouteObject } from "react-router-dom";
import { CreateBusinessProfile } from "../features/business-profile/pages/create.page";
import { ViewBusinessProfile } from "../features/business-profile/pages/view.page";
import { WithAuth } from "../components/layout/with-auth/with-auth.component";

export const businessProfilesRoutes: RouteObject[] = [
  {
    path: "/b",
    element: (
      <WithAuth>
        <ViewBusinessProfile />
      </WithAuth>
    ),
  },
  {
    path: "/b/create",
    element: (
      <WithAuth>
        <CreateBusinessProfile />
      </WithAuth>
    ),
  },
  {
    path: "/b/edit",
    element: (
      <WithAuth>
        <CreateBusinessProfile editing />
      </WithAuth>
    ),
  },
  {
    path: "/b/:customURL",
    element: <ViewBusinessProfile />,
  },
];
